import React from 'react'
import ReactDOM from 'react-dom'
import Bugsnag from '@bugsnag/js'
import BugsnagPluginReact from '@bugsnag/plugin-react'
import ErrorHandler from './components/ErrorBoundaryFallBack/ErrorHandler'
import { getBugsnagKey } from './constants'
import { loadConfig } from './config'
import App from './App'

loadConfig().then(() => {
  const bugsnagKey = getBugsnagKey()

  if (bugsnagKey) {
    Bugsnag.start({
      apiKey: bugsnagKey,
      plugins: [new BugsnagPluginReact()],
    })
  }

  const ErrorBoundary = bugsnagKey
    ? Bugsnag.getPlugin('react').createErrorBoundary(React)
    : ({ children }) => children

  ReactDOM.render(
    <ErrorBoundary FallbackComponent={ErrorHandler}>
      <App />
    </ErrorBoundary>,
    document.getElementById('root')
  )
})
